import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { NotificationService } from 'src/app/shared';
import { TabsComponent } from 'src/app/shared/widgets/tabs';
import { EcomItemImageDto } from '../shared/dto/ecom-item-image.dto';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';
import { EcomShippingItemTypeDto } from '../shared/dto/ecom-shipping-item-type.dto';
import { EcomService } from '../shared/ecom.service';

@Component({
  selector: 'wl-ecom-item-settings-dialog',
  templateUrl: './ecom-item-settings-dialog.component.html',
  styleUrls: ['./ecom-item-settings-dialog.component.less'],
    standalone: false
})
export class EComItemSettingsDialogComponent implements OnInit, OnChanges {
  @ViewChild(TabsComponent, { static: false }) ecomItemTabs: TabsComponent;
  @Input() show = false;
  @Output() showChange = new EventEmitter<boolean>();
  @Input() ecommerceItemId: number;
  eCommerceItem: EcomItemDto;
  busy = false;
  shippingItemTypes: Array<EcomShippingItemTypeDto>;
  eComItemImages: Array<EcomItemImageDto>;
  selectedPrimaryImage: string;
  isSaving: boolean = false;
  isLoading: boolean = false;
  errorMessage: string;
  @Output() itemSaved = new EventEmitter<boolean>();
  constructor(private _ecomService: EcomService, private _notificationService: NotificationService) {}

  ngOnInit() {}

  async ngOnChanges(changes: SimpleChanges) {}

  saveClicked() {
    if (this.eCommerceItem.MemberPrice == null) {
      this.eCommerceItem.MemberPrice = this.eCommerceItem.Price;
    }

    this.show = true;
    this.isSaving = true;
    this.errorMessage = '';

    this._ecomService
      .PostItemEdit({ ecommerceItem: this.eCommerceItem, ecommerceShippingItemTypes: this.shippingItemTypes })
      .then((ItemId) => {
        if (ItemId > 0) {
          let recentlyUploadedFiles = this.eComItemImages?.filter((x) => x.S3Url.toString().includes('data:'));
          if (recentlyUploadedFiles?.length > 0) {
            this._ecomService
              .InsertEcomItemImages(
                ItemId,
                recentlyUploadedFiles.map((m) => m.S3File)
              )
              .then(() => {
                this._ecomService.GetEcomItemImages(ItemId, true).then((data) => {
                  if (this.selectedPrimaryImage) {
                    let fileNames = data?.map((x) => x.S3Url?.toString().substring(x.S3Url.toString().lastIndexOf('/') + 1));
                    let primaryImageIndex = fileNames?.findIndex((x) => x == this.selectedPrimaryImage);
                    this.eCommerceItem.ImageUrl = data[primaryImageIndex]?.S3Url.toString();
                    this.eCommerceItem.ItemId = ItemId;
                    this._ecomService.UpdateEcomItemImage(this.eCommerceItem);
                  }
                });
              });
          } else {
            this.eCommerceItem.ItemId = ItemId;
            this._ecomService.UpdateEcomItemImage(this.eCommerceItem);
          }
          this._notificationService.translateSuccess('ecommerce.ecommerce-list.ecom-item-save-message');
          this.show = false;
          this.itemSaved.emit(true);
        }
      })
      .catch((error: any) => {
        this.errorMessage = error?.error?.Message || 'An unexpected error occurred.';
        this.itemSaved.emit(true);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  async loadItem(ecommerceItemId: number) {
    this.isLoading = true;
    if (this.ecomItemTabs && !this.ecomItemTabs.isOnFirstTab) {
      this.ecomItemTabs.selectFirst();
    }
    this.eCommerceItem = { Inactive: false, ItemId: 0, ItemOptionTypes: [], ShowAsTeaserIfRestricted: true } as EcomItemDto;
    this.shippingItemTypes = [];
    this.show = true;
    if (ecommerceItemId) {
      this.eCommerceItem = await this._ecomService.GetItem(ecommerceItemId);
    }
    this.isLoading = false;
  }

  shippingItemTypeChanged(shippingItemTypes: Array<EcomShippingItemTypeDto>) {
    this.shippingItemTypes = shippingItemTypes;
  }

  customFieldItemValueChanged(eCommerceItem: EcomItemDto) {
    this.eCommerceItem.CustomFieldValues = eCommerceItem.CustomFieldValues;
  }

  affCodeChanged(eCommerceItem: EcomItemDto) {
    this.eCommerceItem.RestrictToAffCodes = eCommerceItem.RestrictToAffCodes;
  }

  eComItemImagesChanged($event) {
    if ($event.eCommerceItem) {
      this.eCommerceItem.ImageUrl = $event.eCommerceItem.ImageUrl;
      this.eComItemImages = $event.eComItemImages;
      this.selectedPrimaryImage = $event.selectedPrimaryImage;
    }
  }

  setShow(value: boolean) {
    this.show = value;
  }

  isSaveDisabled(): boolean {
    return (
      this.isSaving ||
      !this.eCommerceItem?.Title ||
      !this.eCommerceItem?.ItemNum ||
      !this.eCommerceItem?.ItemTypeId ||
      this.hasInvalidShippingType() ||
      this.hasInvalidEComItemOptions()
    );
  }

  hasInvalidShippingType(): boolean {
    return this.shippingItemTypes?.some((item) => item.ShippingTypeId == null || item.ShippingTypeId === 0);
  }

  hasInvalidEComItemOptions(): boolean {
    return this.eCommerceItem?.ItemOptionTypes?.some((optionType) =>
      optionType.EComItemOptions?.some((option) => option.AddToPrice === null || option.AddToPrice === undefined)
    );
  }
}
